import * as types from '../mutation-types';
import ConversationAPI from '../../api/conversations';

// Stores, per conversation id, the titles of the current user's private
// (personal) labels. Mirrors the `conversationLabels` module but talks to the
// private labels endpoint, which is always scoped to the requesting user.
const state = {
  records: {},
  uiFlags: {
    isFetching: false,
    isUpdating: false,
    isError: false,
  },
};

export const getters = {
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getConversationPrivateLabels: $state => id => {
    return $state.records[Number(id)] || [];
  },
};

export const actions = {
  get: async ({ commit }, conversationId) => {
    commit(types.default.SET_CONVERSATION_PRIVATE_LABELS_UI_FLAG, {
      isFetching: true,
    });
    try {
      const response = await ConversationAPI.getPrivateLabels(conversationId);
      commit(types.default.SET_CONVERSATION_PRIVATE_LABELS, {
        id: conversationId,
        data: response.data.payload,
      });
      commit(types.default.SET_CONVERSATION_PRIVATE_LABELS_UI_FLAG, {
        isFetching: false,
      });
    } catch (error) {
      commit(types.default.SET_CONVERSATION_PRIVATE_LABELS_UI_FLAG, {
        isFetching: false,
      });
    }
  },
  update: async ({ commit }, { conversationId, labels }) => {
    commit(types.default.SET_CONVERSATION_PRIVATE_LABELS_UI_FLAG, {
      isUpdating: true,
    });
    try {
      const response = await ConversationAPI.updatePrivateLabels(
        conversationId,
        labels
      );
      commit(types.default.SET_CONVERSATION_PRIVATE_LABELS, {
        id: conversationId,
        data: response.data.payload,
      });
      commit(types.default.SET_CONVERSATION_PRIVATE_LABELS_UI_FLAG, {
        isUpdating: false,
        isError: false,
      });
    } catch (error) {
      commit(types.default.SET_CONVERSATION_PRIVATE_LABELS_UI_FLAG, {
        isUpdating: false,
        isError: true,
      });
    }
  },
  setBulkConversationPrivateLabels({ commit }, conversations) {
    commit(types.default.SET_BULK_CONVERSATION_PRIVATE_LABELS, conversations);
  },
  setConversationPrivateLabel({ commit }, { id, data }) {
    commit(types.default.SET_CONVERSATION_PRIVATE_LABELS, { id, data });
  },
};

export const mutations = {
  [types.default.SET_CONVERSATION_PRIVATE_LABELS_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [types.default.SET_CONVERSATION_PRIVATE_LABELS]: ($state, { id, data }) => {
    $state.records = { ...$state.records, [id]: data };
  },
  [types.default.SET_BULK_CONVERSATION_PRIVATE_LABELS]: (
    $state,
    conversations
  ) => {
    const updatedRecords = { ...$state.records };
    conversations.forEach(conversation => {
      updatedRecords[conversation.id] = conversation.private_labels || [];
    });

    $state.records = updatedRecords;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
